import React from "react";

function Coverage() {
  return (
    <div style={{ padding: "30px" }}>
      <h1>Coverage Options</h1>
      <p>
        Explore available vehicle-related coverage options from trusted partners.
      </p>

      <div style={{ marginTop: "30px", padding: "20px", background: "#f2f2f2" }}>
        <h3>Premierline Coverage</h3>
        <p>
          Click the button below to view available coverage options provided
          through our approved partner.
        </p>

        <a
          href="https://www.awin1.com/cread.php?awinmid=16315&awinaffid=2959523&ued=https%3A%2F%2Fukmotorassist.net%2Fcoverage"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            marginTop: "20px",
            padding: "12px 25px",
            background: "#0A3D62",
            color: "white",
            textDecoration: "none",
            borderRadius: "5px",
            fontWeight: "bold"
          }}
        >
          View Coverage
        </a>
      </div>
    </div>
  );
}

export default Coverage;
